import React, { Component } from "react";
import { Progress } from "reactstrap";
import "react-accessible-accordion/dist/fancy-example.css";
import Header from "../../Layout/Header/Header-loggedIn";
import hint_yes from "../../../Assets/img/Group 648.svg";
import hint_no from "../../../Assets/img/Group 649.svg";
import Heart from "../../../Assets/img/Union 2.svg";
import {
  make_request,
  authenticate,
  download_the_asset,
  seconds_to_clock,
  fetch_client_country,
} from "../../Utils/Utils";
// import "@lottiefiles/lottie-player";
import {
  clock,
  left_panel,
  RightSidePanel,
  CompletedLevel,
  LeaderBoard,
  LeaderBoard_mobile,
  clock_in_words,
} from "./level_partials";
import ReactTooltip from "react-tooltip";
import CloseSource from "../../../Assets/img/Group 2523.svg";
import hljs from "highlight.js/lib/core";
import "highlight.js/styles/monokai-sublime.css";
import xml from "highlight.js/lib/languages/xml";
import LevelProgress from "../../Components/LevelProgress/LevelProgress";
import TourApp from '../../Tour/TourApp';
import CarouselLevelImages from './CarouselLevelImages';

hljs.registerLanguage("xml", xml);

class LevelPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      progress_width: 0,
      show: true,
      is_modal_open: false,
      hintPack: false,
      level: {},
      skills: [],
      sponsors: [],
      complexity: "easy",
      successRate: {},
      levelProgression: {},
      show_this_hint: [],
      level_completed: false,
      answer: "",
      recent_answers: [],
      totalTimeInSec: 3600, // 30 minutes
      leftClassList: ["col-xl-2 col-lg-12 col-md-12 col-12"],
      rightClassList: ["card recent-answers mt-4"],
      centerClassList: [""],
      focus_sec: ["focus_grow"],
      hide_common: ["focus_hide"],
      align_timer: ["d-flex align-content-center top-area"],
      align_hint: ["top-area"],
      hints: {},
      unlocked_hints: [],
      opened_hint: [],
      level_name: "",
      show_animation: false,
      interval: null,
      tooltip_text: "",
      level_time: "00:00",
      level_time_in_words: "0 minutes and 0 seconds",
      time_elapsed: 0,
      branch_level: false,
      pageTitle: "Puzzled",
      isTourOpen: false
    };
  }

  get_view_source = () => {
    this.setState({
      is_modal_open: true,
    });
  };

  close_modal = () => {
    this.setState({ is_modal_open: false });
  };

  // componentDidUpdate() {
  //   if ( this.state.progress_width === 100 )
  //   {
  //     clearInterval(this.state.interval);
  //   }
  // }

  hintMargin = (time_to_unlock) => {
    let maxMargin = 97;
    let calculatedMargin = Math.round(
      (time_to_unlock / this.state.totalTimeInSec) * 100
    );
    return (calculatedMargin > maxMargin ? maxMargin : calculatedMargin) + "%";
  };

  hint_hover_txt(hint) {
    var text = "click to open the hint";
    var seconds = hint.time_to_unlock - this.state.progress_width;
    if (seconds > 0 && !hint.unlocked) {
      var clock = seconds_to_clock(seconds * 1000);
      if (clock["hours"] > 0) {
        text = "unlocks in " + clock["hours"] + " hour";
      } else if (clock["minutes"] > 0) {
        if (clock["minutes"] > 1) {
          text = "unlocks in " + clock["minutes"] + " minutes";
        } else {
          text = "unlocks in " + clock["minutes"] + " minute";
        }
      } else if (clock["seconds"] > 0) {
        if (clock["seconds"] > 1) {
          text = "unlocks in " + clock["seconds"] + " seconds";
        } else {
          text = "unlocks in " + clock["seconds"] + " second";
        }
      }
    }
    return text;
  }

  async open_hint(hint) {
    if (hint.unlocked) {
      await this.setState({
        opened_hint: [hint.hint],
      });
    } else {
      await this.setState({
        opened_hint: [],
      });
    }
  }

  async open_all_hints() {
    await this.setState({ opened_hint: this.state.unlocked_hints });
  }

  getUnlockedCount() {
    let unlockedcount = 0;
    Object.values(this.state.hints).map((hint) => {
      if (hint.unlocked) {
        unlockedcount = unlockedcount + 1;
      }
      return unlockedcount;
    });
    return unlockedcount;
  }

  close_hint(hint) {
    this.setState({
      opened_hint: [],
    });
  }

  update_hint_info = async (hint_id) => {
    let responseJson = await make_request({
      path: "hint_info",
      method: "POST",
      body: { level_id: this.state.level_id },
    });
    if (responseJson) {
      this.setState(
        {
          hints: responseJson["hints"],
          unlocked_hints: responseJson["unlocked_hints"],
        },
        () => {
          return this.open_hint(this.state.hints[hint_id]);
        }
      );
    }
  };

  toggleCart = () => {
    let tempArray = [];
    Object.values(this.state.hints).map((hint) => {
      if (!hint.unlocked) {
        tempArray.push(hint);
      }
      return tempArray;
    });
    this.setState({ opened_hint: tempArray });
  };

  set_view_source = () => {
    // source hint section
    var comment = "";
    var comment =
      "All that matters starts here\n" +
      (this.state.level.source_hint || "") +
      "\nAll that matters ends here";
    var source_hint = document.createComment(comment);
    var first_node = document.querySelector("#body_first_node");
    first_node.parentNode.insertBefore(source_hint, first_node);
    // view source section
    var pre_code = document.querySelector("#view_source pre code");
    var level_body =
      '<!DOCTYPE html><html lang="en"><head><title>' +
      (this.state.level.title_hint || "Puzzled") +
      '</title><meta charset="utf-8" /><meta name="viewport" content="width=device-width, initial-scale=1" /></head><body><div id="level_body" class="innerBody">' +
      document.querySelector("#level_body").innerHTML +
      "</div></body></html>";
    pre_code.append(level_body.replace(/>/g, ">\n"));
    hljs.highlightBlock(pre_code);
  };

  set_level_timer = async () => {
    if (this.state.level.time_taken !== null) {
      // branch picking level did'nt need timer so it will be 00:00:00
      await this.setState({
        level_time: clock(this.state.level.time_taken),
        level_time_in_words: clock_in_words(this.state.level.time_taken),
        progress_width: this.state.level.time_taken,
        totalTimeInSec: this.state.totalTimeInSec,
      });
    } else {
      await this.setState({
        progress_width: this.state.time_elapsed,
        totalTimeInSec: this.state.totalTimeInSec,
      });
      setInterval(() => {
        this.setState(
          {
            level_time: clock(this.state.time_elapsed + 1),
            level_time_in_words: clock_in_words(this.state.time_elapsed + 1),
            time_elapsed: this.state.time_elapsed + 1,
            totalTimeInSec: this.state.totalTimeInSec,
            progress_width: this.state.progress_width + 1,
          },
          () => {
            Object.values(this.state.hints).map((hint) => {
              if (this.state.progress_width === hint.time_to_unlock) {
                this.update_hint_info(hint.id);
              }
              return true;
            });
          }
        );
      }, 1000);
    }
  };

  fetch_request = async (country_code = null) => {
    const { edition_id, level_name, asset } = this.props.match.params;
    let responseJson = await make_request({
      path: "get_level",
      method: "POST",
      body: {
        edition_id: edition_id,
        level_name: level_name,
        asset: asset,
        country_code: country_code,
      },
    });
    if (responseJson && responseJson.status === "success") {
      if (!!responseJson["redirect_to"]) {
        return (window.location = responseJson["redirect_to"]);
      } else if (
        responseJson["level"]["geo_images_available"] &&
        country_code === null
      ) {
        let country_code = await fetch_client_country();
        // alert("country code..." + country_code) ;
        if (!country_code || country_code === "Not found") country_code = "IN";
        this.fetch_request(country_code);
      } else {
        if (responseJson.from_get_asset) {
          if (!!responseJson.asset_url) {
            download_the_asset(responseJson.asset_url, asset);
          }
        }
        this.setState(
          {
            level_id: responseJson["level"]["id"],
            level: responseJson["level"],
            pageTitle: responseJson["level"]["title_hint"],
            hints: responseJson["hints"],
            totalTimeInSec: responseJson["max_hint_time"],
            complexity: responseJson["complexity"],
            successRate: responseJson["success_rate"],
            levelProgression: responseJson["level_progression"],
            skills: responseJson["skills"] || [],
            sponsors: responseJson["sponsors"] || [],
            unlocked_hints: responseJson["unlocked_hints"] || [],
            time_elapsed: responseJson["level"]["time_elapsed"] || 0,
            level_completed: responseJson["level_completed"] || false,
            branch_level:
              responseJson.level.coords && responseJson.level.coords.length > 0,
          },
          () => {
            if (this.state.level.answer) {
              this.setState({
                recent_answers: [this.state.level.answer + "_level_answer"],
              });
            }
            if (this.state.level.dark_text || this.state.level.warmup_edition) {
              this.set_view_source();
            }
            this.set_level_timer();
          }
        );
        document.title = this.state.pageTitle;
      }
    } else {
      return (window.location = "/not-found");
    }
  };

  async componentDidMount() {
    if (authenticate()) {
      this.fetch_request();
      document.title = this.state.pageTitle;
      if ((this.state.time_elapsed > 0) && (this.state.time_elapsed < 300)) { // 5 minutes
        this.toggle_tour()
      }
    } else {
      this.props.history.push("/login");
    }
  }

  changeName = () => {
    let text = "Focus mode ";
    text += this.state.show === true ? "on" : "off";
    return text;
  };

  showHide = () => {
    this.setState({ show: !this.state.show });
    if (this.state.show) {
      this.state.leftClassList.push("visibleAlone");
      this.state.rightClassList.push("visibleAlone");
      this.state.centerClassList.push("visibleAlone");
      this.state.hide_common.push("visibleAlone");
      this.state.focus_sec.push("visible");
      this.state.align_timer.push("left_align");
      this.state.align_hint.push("left_align_hint");
    } else {
      this.setState({
        leftClassList: ["col-xl-2 col-lg-12 col-md-12 col-12"],
        rightClassList: ["card recent-answers mt-4"],
        hide_common: ["focus_hide"],
        centerClassList: [],
        focus_sec: ["focus_grow"],
        align_timer: ["d-flex align-content-center top-area"],
        align_hint: ["top-area"],
      });
      // this.state.leftClassList = ["col-xl-2 col-lg-12 col-md-12 col-12"];
      // this.state.rightClassList = ["card recent-answers mt-4"];
      // this.state.hide_common = ["focus_hide"];
      // this.state.centerClassList = [];
      // this.state.focus_sec = ["focus_grow"];
      // this.state.align_timer = ["d-flex align-content-center top-area"];
      // this.state.align_hint = ["top-area"];
    }
  };

  handle_change = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  enter_pressed = (event) => {
    let code = event.keyCode || event.which;
    if (code === 13) {
      this.submit_answer();
    }
  };

  submit_answer = async (ans) => {
    let answer,
      level_id = null;
    if (ans) {
      answer = ans;
      if (this.state.branch_level) {
        level_id = this.state.level_id;
      }
    } else {
      answer = this.state.answer;
      level_id = this.state.level_id;
    }
    if (!!answer) {
      let responseJson = await make_request({
        path: "check_answer",
        method: "POST",
        body: { level_id: level_id, answer: answer },
      });
      if (responseJson) {
        // console.log("=== responseJson : " + JSON.stringify(responseJson));
        if (responseJson.status === "game_completed") {
          return this.setState(
            {
              show_animation: true,
              animation_url:
                process.env.REACT_APP_API_URL +
                "/animations/success/level_up_" +
                (Math.floor(Math.random() * 5) + 1) +
                ".json",
            },
            () => {
              setTimeout(() => {
                // window.location = "/hall-of-fame";
                window.location = "/winner/" + this.state.level.edition_id;
              }, 4000);
            }
          );
        } else if (responseJson.status === "success") {
          if (this.state.branch_level) {
            window.location = responseJson["redirect_to"];
          } else {
            return this.setState(
              {
                show_animation: true,
                animation_url:
                  process.env.REACT_APP_API_URL +
                  "/animations/success/level_up_" +
                  (Math.floor(Math.random() * 5) + 1) +
                  ".json",
              },
              () => {
                setTimeout(() => {
                  window.location = responseJson["redirect_to"];
                }, 4000);
              }
            );
          }
        } else {
          let recent_answers = this.state.recent_answers.reverse() || [];
          recent_answers.push(this.state.answer);
          this.setState({
            answer: "",
            recent_answers: recent_answers.reverse(),
          });
          if (responseJson.close_answer) {
            this.setState(
              {
                show_animation: true,
                animation_url:
                  process.env.REACT_APP_API_URL +
                  "/animations/intermediate/so_close_" +
                  (Math.floor(Math.random() * 6) + 1) +
                  ".json",
              },
              () => {
                setTimeout(() => {
                  this.setState({
                    show_animation: false,
                    animation_url: "",
                  });
                }, 4000);
              }
            );
          }
        }
      }
    }
  };

  get_responsive_coords = (coord_array) => {
    let map_worker = document.querySelector("[usemap='#workmap']");
    if (map_worker && coord_array.length) {
      coord_array[0] = ((map_worker.width / map_worker.naturalWidth) * parseInt(coord_array[0])).toFixed();
      coord_array[1] = ((map_worker.height / map_worker.naturalHeight) * parseInt(coord_array[1])).toFixed();
      if(coord_array.length > 3) {
        coord_array[2] = ((map_worker.width / map_worker.naturalWidth) * parseInt(coord_array[2])).toFixed();
        coord_array[3] = ((map_worker.height / map_worker.naturalHeight) * parseInt(coord_array[3])).toFixed();
      } else {
        coord_array[2] = ((map_worker.width / map_worker.naturalWidth) * parseInt(coord_array[2])).toFixed();
      }
    }
    return coord_array.join(",");
  };

  get_level_image = (level) => {
    if (level.image || level.geo_images_available) {
      if (level.carousel_images && level.image.length > 0) {
        return <CarouselLevelImages images={level.image} />
      } else if (level.coords && level.coords.length > 0) {
        var map = {
          name: "workmap",
          areas: [],
        };
        level.coords.map((coord, index) => {
          var coord_array = coord.split(",");
          var shape = "poly";
          if (coord_array.length === 3) {
            shape = "circle";
          } else if (coord_array.length === 4) {
            shape = "rect";
          } else {
            shape = "poly";
          }
          map["areas"].push({
            name: (index + 1).toString(),
            shape: shape,
            coords: coord_array,
            href: this.state.level.map,
          });
          return map["areas"];
        });
        if (this.state.level.answer_template === "click")
          return (
            <React.Fragment>
              <img
                src={level.geo_images_available ? level.geo_image : level.image}
                alt="level_image"
                className="card-img img-scale main-image"
                useMap="#workmap"
                onLoad={() => this.setState({ map_image_loaded: true })}
              />
              <map name="workmap">
                {this.state.map_image_loaded &&
                  map["areas"].map((area, inx) => {
                    return (
                      <area
                        key={inx}
                        shape={area.shape}
                        coords={this.get_responsive_coords(area.coords)}
                        href={this.state.level.map}
                      />
                    );
                  })}
              </map>
            </React.Fragment>
          );
        else
          return (
            <React.Fragment>
              <img
                src={level.geo_images_available ? level.geo_image : level.image}
                alt="level_image"
                className="card-img img-scale main-image"
                useMap="#workmap"
                onLoad={() => this.setState({ map_image_loaded: true })}
              />
              <map name="workmap">
                {this.state.map_image_loaded &&
                  map["areas"].map((area, inx) => {
                    const org_coords = area.coords.join(",")
                    return (
                      <area
                        key={inx}
                        shape={area.shape}
                        style={{ cursor: "pointer" }}
                        onClick={() => this.submit_answer(org_coords)}
                        coords={this.get_responsive_coords(area.coords)}
                        href={this.state.level.map}
                      />
                    );
                  })}
              </map>
            </React.Fragment>
          );
      } else if (!!level.embed_url) {
        return (
          <div dangerouslySetInnerHTML={{__html: level.embed_url}} />
        );
      } else {
        return (
          <img
            src={level.geo_images_available ? level.geo_image : level.image}
            alt="level_image"
            className="card-img img-scale main-image"
          />
        );
      }
    }
  };

  toggle_tour = () => this.setState({isTourOpen: !this.state.isTourOpen})

  render() {
    const {
      totalTimeInSec,
      progress_width,
      level_time,
      level,
      skills,
      sponsors,
      recent_answers,
      complexity,
      successRate,
    } = this.state;
    const showTour = ["1", "2"].includes(level.number);
    const tourLabel = level.number === "2" ? "Continue Tour" : "Take A Tour";
    return (
      <div>
        <ReactTooltip />
        <div id="level_body" className="innerBody">
          <div
            id="body_first_node"
            className={this.state.centerClassList.join(" ")}
          >
            <Header />
          </div>
          <div className="container mt-2 levelpage mb-5">
            <div className="row d-flex align-items-stretch">
              <div className="col-4 pl-3 pt-2 pb-2 pr-0 flex-grow-1  d-xl-block d-lg-none d-md-none d-sm-none d-none">
                <div className={this.state.hide_common.join(" ")}>
                  {Object.entries(this.state.hints).length > 0 && (
                    <Progress multi>
                      <Progress
                        bar
                        color="custom"
                        value={progress_width}
                        max={totalTimeInSec}
                      />
                    </Progress>
                  )}
                  <div className="progress-icon d-flex">
                    {/* desktop screen */}
                    {Object.entries(this.state.hints).map(([id, hint], inx) => {
                      return (
                        <span key={id}>
                          <ReactTooltip
                            id={`hint_${id}`}
                            getContent={[
                              () => {
                                return this.hint_hover_txt(hint);
                              },
                            ]}
                          ></ReactTooltip>
                          <img
                            data-tut={((document.querySelector('#root').offsetWidth > 760) && (inx === 0)) ? "reactour__hints" : ""}
                            key={id}
                            src={hint.unlocked ? hint_yes : hint_no}
                            height="20"
                            width="20"
                            alt="hint"
                            onClick={() => {
                              this.open_hint(hint);
                            }}
                            data-for={`hint_${id}`}
                            data-tip=""
                            className="hint-icon"
                            style={{
                              left: this.hintMargin(hint.time_to_unlock),
                            }}
                          />
                        </span>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className="col-6 d-flex ">
                <div className={this.state.hide_common.join(" ")}>
                  <CompletedLevel level={level} />
                </div>
                <LevelProgress
                  levelProgress={this.state.levelProgression.progress}
                  levels={this.state.levelProgression.total_levels}
                  levelsCompleted={this.state.levelProgression.levels_completed}
                />
                <div className="col-1 d-xl-block d-lg-none d-md-none d-sm-none d-none">
                  <div className={this.state.hide_common.join(" ")}>
                    <div className="icon4 avatar-square-xsm">
                      <ReactTooltip
                        id="timer"
                        getContent={[
                          () => {
                            if (this.state.level_completed) {
                              return (
                                "You solved this level in " +
                                this.state.level_time_in_words
                              );
                            } else {
                              return (
                                "Tick tock. You are at this level since " +
                                this.state.level_time_in_words
                              );
                            }
                          },
                        ]}
                      ></ReactTooltip>
                      <span className="timers" data-for="timer" data-tip="">
                        {level_time}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-1 ml-4 d-xl-block d-lg-none d-md-none d-sm-none d-none">
                <div className={this.state.hide_common.join(" ")}>
                  {Object.entries(this.state.hints).length > 0 && (
                    <a className="pl-4 mt-5">
                      <img
                        src={Heart}
                        className="cart"
                        data-tip="click to open all unlocked hints"
                        onClick={() => this.open_all_hints()}
                        alt=""
                      />
                      <span className="badge badge-warning" id="lblCartCount">
                        {this.getUnlockedCount()}
                      </span>
                    </a>
                  )}
                </div>
              </div>

              <div className={this.state.leftClassList.join(" ")}>
                {left_panel(skills, complexity, successRate)}
              </div>

              {/*MOBILE VIEW LEVEL DROP_DOWN TIMER & HINT_PROGRESS SECTION START*/}

              {/* LEVEL_DROP_DOWN */}

              <div className="col-6 d-xl-none d-lg-block d-md-block d-sm-block d-block ">
                <CompletedLevel level={level} screen="mobile" />
              </div>

              {/* TIMER */}

              <div className="col-2 offset-lg-3 offset-md-3 offset-2 text-left d-xl-none d-lg-block d-md-block d-sm-block d-block ">
                <div className="icon4 avatar-square-xsm">
                  <span className="timers">{level_time}</span>
                </div>
              </div>

              {/* HEART_HINT */}

              <div className="d-xl-none d-lg-block d-md-block d-sm-block d-block"></div>

              {/*PROGRESS BAR*/}

              <div className="col-11 pt-2 pb-2 mt-3 mb-3 flex-grow-1  d-xl-none d-lg-block d-md-block d-sm-block d-block">
                <div className={this.state.hide_common.join(" ")}>
                  {Object.entries(this.state.hints).length > 0 && (
                    <Progress multi>
                      <Progress
                        bar
                        color="custom"
                        value={progress_width}
                        max={totalTimeInSec}
                      />
                    </Progress>
                  )}
                  <div className="progress-icon d-flex">
                    {/* mobile screen */}
                    {Object.entries(this.state.hints).map(([id, hint], inx) => {
                      return (
                        <img
                          data-tut={((document.querySelector('#root').offsetWidth < 760) && (inx === 0)) ? "reactour__hints" : ""}
                          key={id}
                          src={hint.unlocked ? hint_yes : hint_no}
                          height="20"
                          width="20"
                          alt="hint"
                          onClick={() => {
                            this.open_hint(hint);
                          }}
                          title={this.hint_hover_txt(hint)}
                          className="hint-icon"
                          style={{
                            left: this.hintMargin(hint.time_to_unlock)
                          }}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>

              {/*MOBILE VIEW RECENT ANSERS AND SKILLS LEADER_BOARD SECTION END*/}

              <div
                className="col-xl-8 col-lg-12 col-md-12 col-12 level_img_sec"
                id="view"
              >
                <div className={this.state.focus_sec.join(" ")}>
                  <div className="mt-4 card shadow-0 border-0 text-white text-center" style={!!level.embed_url ? {backgroundColor: "#000"} : {}}>
                    <div data-tut="reactour__level">
                    {this.get_level_image(level)}
                    </div>
                    <div className="hints_area align-items-center p-0">
                      {this.state.opened_hint.length > 0 &&
                        this.state.opened_hint.map((hint, index) => {
                          return (
                            <div key={index} className="py-2 w-100">
                              <div className="dialog pl-4 pr-4">
                                <p>{hint}</p>
                                <button
                                  onClick={() => this.close_hint(hint)}
                                  className="btn btn-yellow"
                                >
                                  OK
                                </button>

                                <a
                                  href="javascript:void(0);"
                                  onClick={() => this.close_hint(hint)}
                                  className="close-classic"
                                >
                                  &nbsp;
                                </a>
                              </div>
                            </div>
                          );
                        })}
                      <div className="level_up_animation">
                        {this.state.animation_url !== "" &&
                          this.state.show_animation && (
                            <div className="innerBody">
                               <lottie-player
                                autoplay
                                mode="normal"
                                src={this.state.animation_url}
                                className="animation_height"
                                style={{
                                  width: "100%",
                                  alignItems: "center",
                                  opacity: "0.9",
                                  background:
                                    "rgba(74, 92, 179, 0.9) !important",
                                }}
                              ></lottie-player>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className={this.state.hide_common.join(" ")}>
                  {level.audio ? (
                    <div className="card mt-4 card-black mb-4 align-items-center">
                      <div>
                      {
                        (level.source_hint && !level.warmup_edition) &&
                        <p className="mb-1">
                          <div>
                          <span>{level.source_hint}</span>
                          <br/>
                          </div>
                        </p>
                      }
                      <audio src={level.audio} type="audio" controls />
                      </div>
                    </div>
                  ) : level.description ? (
                    <div className="card mt-4 card-black mb-4 align-items-center">
                      <p className="mb-1">
                        {
                          (level.source_hint && !level.warmup_edition) &&
                          <div>
                          <span>{level.source_hint}</span>
                          <br/>
                          </div>
                        }
                        <span
                          style={
                            level.dark_text && { color: "#1A1A1A" }
                          }
                        >
                          {level.description}
                        </span>
                      </p>
                    </div>
                  ) : (level.source_hint && !level.warmup_edition) ? (
                    <div className="card mt-4 card-black mb-4 align-items-center">
                    <p className="mb-1">
                      <div>
                      <span>{level.source_hint}</span>
                      <br/>
                      </div>
                    </p>
                    </div>
                  ) : (
                    <br />
                  )}

                  {/* <div id="open-modal" className="modal-window">
                    <div>
                      <div className="modal_header">
                        <a
                          href="#modal-close"
                          title="Close"
                          className="modal-close"
                        >
                          <img src={CloseSource} alt="close" />
                        </a>
                      </div>
                      
                      <div className="modal_footer"> </div>
                    </div>
                  </div> */}

                  {
                    (level.dark_text || level.warmup_edition) &&
                    <div className="modal-container">
                      <input id="modal-toggle" type="checkbox" />
                      <div className="text-center">
                        <button type="button" className="btn btn-yellow" data-tut="reactour__source">
                          {" "}
                          VIEW SOURCE{" "}
                        </button>
                      </div>
                      <div className="modal-backdrop">
                        <div className="modal-content">

                          <label className="modal-close" htmlFor="modal-toggle">
                            <img src={CloseSource} alt="close" />
                          </label>
                          <div id="view_source">
                            <pre>
                              <code className="language-html"></code>
                            </pre>
                          </div>

                        </div>
                      </div>
                    </div>
                  }
                  {/* <div className="text-center">
                    <a href="#open-modal">
                      <button type="button" className="btn btn-yellow">
                        {" "}
                        VIEW SOURCE{" "}
                      </button>
                    </a>
                  </div> */}
                </div>

                {/*MOBILE VIEW RECENT ANSERS AND SKILLS LEADER_BOARD SECTION START*/}

                {/*RECENT_ANSERS*/}

                <div className="mb-4">
                  <RightSidePanel
                    secondaryClassName={this.state.rightClassList.join(" ")}
                    recentAnswers={recent_answers}
                    onToggleTour={this.toggle_tour}
                    mobile={true}
                    showTour={showTour}
                    tourLabel={tourLabel}
                  />
                </div>

                <div className="col-12 pt-2 mb-5 text-center leader_brd d-xl-none d-lg-block d-md-block d-sm-block d-block">
                  <LeaderBoard_mobile editionId={this.state.level.edition_id} />
                  ​
                </div>

                {/*MOBILE VIEW RECENT ANSERS AND SKILLS LEADER_BOARD SECTION END*/}

                <div className={this.state.focus_sec.join(" ")}>
                  <div className="row ml-1 mb-5 fmode_dis_visiblity d-xl-block d-lg-block d-md-none d-sm-none d-none">
                    <div id="disqus_thread" data-tut="reactour__disqus"></div>
                  </div>
                </div>

                <div className={this.state.focus_sec.join(" ")}>
                  <div className="row fmode_visiblity focus_txt">
                    <div className="col-8">
                      {level.audio ? (
                        <div className="card card-black mb-5 align-items-center">
                          <audio src={level.audio} type="audio" controls />
                        </div>
                      ) : level.description ? (
                        <div className="card card-black mb-5 align-items-center">
                          <p className="mb-1">{level.description}</p>
                        </div>
                      ) : (
                        <br />
                      )}
                    </div>

                    {level.description ? (
                      <div className="col-4">
                        <div className="d-flex">
                          <div className="pt-3">
                            {Object.entries(this.state.hints).length > 0 && (
                              <React.Fragment>
                                <img
                                  src={Heart}
                                  className="cart"
                                  onClick={() => this.open_all_hints()}
                                  alt=""
                                />
                                <span
                                  className="badge badge-warning"
                                  id="lblCartCount"
                                >
                                  {this.getUnlockedCount()}
                                </span>
                              </React.Fragment>
                            )}
                          </div>
                          <div className="ml-4 mt-2 icon4 avatar-square-xsm">
                            <span className="timers">{level_time}</span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <br />
                    )}
                  </div>
                </div>
              </div>
              <RightSidePanel
                secondaryClassName={this.state.rightClassList.join(" ")}
                recentAnswers={recent_answers}
                onToggleTour={this.toggle_tour}
                sponsors={sponsors}
                showTour={showTour}
                tourLabel={tourLabel}
              />
            </div>

            {/* ========= submit button desktop start============= */}

            {this.state.level.answer_template === "answer_box" && (
              <div className="d-xl-block d-lg-block d-md-none d-sm-none d-none">
                <div className="footer-answer d-flex justify-content-center">
                  <div className="form-inline" data-tut={(document.querySelector('#root').offsetWidth > 760) ? "reactour__answer" : ""}>
                    <div className="form-group mx-sm-3 mb-2 answer_field">
                      <label htmlFor="inputPassword2" className="sr-only">
                        Answer here
                      </label>
                      <input
                        name="answer"
                        type="text"
                        placeholder="ANSWER HERE"
                        autoFocus={true}
                        className="form-control answer_field"
                        id="inputPassword2"
                        value={this.state.answer}
                        onChange={this.handle_change}
                        onKeyPress={this.enter_pressed}
                      />
                    </div>
                    <button
                      type="submit"
                      className="btn mb-2"
                      onClick={() => this.submit_answer()}
                    >
                      SUBMIT
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* ========= submit button desktop end============= */}

            {/* ========= submit button mobile ============= */}

            {this.state.level.answer_template === "answer_box" && (
              <div className="d-xl-none d-lg-none d-md-block d-sm-block d-block">
                <div className="mobile-footer-answer">
                  <div className="custom_row" data-tut={(document.querySelector('#root').offsetWidth < 760) ? "reactour__answer" : ""}>
                    <div className="col-8">
                      <input
                        name="answer"
                        type="text"
                        placeholder="ANSWER HERE"
                        autoFocus={true}
                        className="form-control"
                        id="inputPassword2"
                        value={this.state.answer}
                        onChange={this.handle_change}
                        onKeyPress={this.enter_pressed}
                      />
                    </div>
                    <div className="col-4 pl-0">
                      <button className="btn btn-block" onClick={() => this.submit_answer()} type="submit">
                        SUBMIT
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* ========= submit button mobile ============= */}

            <div className="d-xl-block d-lg-none d-md-none d-sm-none d-none">
              <button
                onClick={this.showHide}
                className="btn focus_mode btn-yellow"
              >
                {this.changeName()}
              </button>

              <LeaderBoard
                class_name={this.state.hide_common.join(" ")}
                editionId={this.state.level.edition_id}
              />
            </div>
          </div>
        </div>
        {
          showTour &&
          <TourApp
            level={level.number}
            isTourOpen={this.state.isTourOpen}
            onRequestClose={() => this.setState({isTourOpen: !this.state.isTourOpen})}
          />
        }
      </div>
    );
  }
}


export default LevelPage;
